var _rect, _path, _path2, _path3, _circle, _circle2, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelayedVehicleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 21,
    viewBox: "0 0 30 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 20,
    height: 17,
    rx: 0.5,
    fill: "#E7332F",
    fillOpacity: 0.1,
    stroke: "#E7332F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4677 5.80078H21H20.5V17.5615H21.9783H28.2837H28.5C29.0523 17.5615 29.5 17.1138 29.5 16.5615V11.3052C29.5 11.1063 29.4407 10.9118 29.3295 10.7468L26.2973 6.24235C26.1114 5.96631 25.8005 5.80078 25.4677 5.80078Z",
    fill: "#E7332F",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 19.366H21.5M20.2913 17.5615H20.5M20.5 17.5615H21.9783H28.2837H28.5C29.0523 17.5615 29.5 17.1138 29.5 16.5615V11.3052C29.5 11.1063 29.4407 10.9118 29.3295 10.7468L26.2973 6.24235C26.1114 5.96631 25.8005 5.80078 25.4677 5.80078H21H20.5V17.5615Z",
    stroke: "#E7332F",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 8.2V10.8C22.5 10.9105 22.5895 11 22.7 11H26.6263C26.786 11 26.8813 10.822 26.7927 10.6891L25.0594 8.08906C25.0223 8.03342 24.9598 8 24.893 8H22.7C22.5895 8 22.5 8.08954 22.5 8.2Z",
    fill: "white",
    stroke: "#E7332F",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 18,
    r: 2.5,
    fill: "#FDEBEA",
    stroke: "#E7332F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 18,
    r: 2.5,
    fill: "#FDEBEA",
    stroke: "#E7332F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.64988 4.47864L5.43891 11.5085C5.35209 11.6589 5.30615 11.8293 5.30567 12.003C5.30518 12.1766 5.35016 12.3473 5.43614 12.4981C5.52212 12.649 5.64609 12.7747 5.79573 12.8627C5.94537 12.9508 6.11545 12.9981 6.28906 13H14.711C14.8846 12.9981 15.0547 12.9508 15.2043 12.8627C15.354 12.7747 15.4779 12.649 15.5639 12.4981C15.6499 12.3473 15.6949 12.1766 15.6944 12.003C15.6939 11.8293 15.648 11.6589 15.5611 11.5085L11.3502 4.47864C11.2615 4.33253 11.1368 4.21172 10.9878 4.12788C10.8389 4.04404 10.6709 4 10.5 4C10.3291 4 10.1611 4.04404 10.0122 4.12788C9.8633 4.21172 9.73851 4.33253 9.64988 4.47864Z",
    fill: "#E7332F",
    stroke: "#FDEBEA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7.0332V9.02185",
    stroke: "#FDEBEA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 11.0107H10.5038",
    stroke: "#FDEBEA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelayedVehicleIcon);
export default __webpack_public_path__ + "static/media/delayedVehicleIcon.f751982e9002db22be56ee4de39459aa.svg";
export { ForwardRef as ReactComponent };